<div ngbDropdown placement="bottom-right" class="d-inline-block">
  <button class="btn btn-secondary ms-3" id="dropdownBasic1" ngbDropdownToggle>
    {{customer.companyName}} ({{customer.customerId}})
  </button>
  <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="p-3 dropdown-menu dropdown-menu-end">
    <h5 class="text-center">{{customer.companyName}}</h5>
    <hr />
    <div>
      <h6 class="dropdown-header">{{customer.language}} / {{customer.country}}</h6>
      <h6 class="dropdown-header">Customer ID: {{customer.customerId}}</h6>
      <h6 class="dropdown-header">MerchantId: {{customer.merchantId}}</h6>
      <h6 class="dropdown-header">Contact Name: {{customer.contactName}}</h6>
      <h6 class="dropdown-header">Contact Email: {{customer.contactEmail}}</h6>
      <h6 class="dropdown-header">Contact Phone: {{customer.contactPhone}}</h6>
    </div>
  </div>
</div>
